/**
 * Map a concrete pathname to a route TEMPLATE so the `route` field on emitted
 * events stays low-cardinality (`/tools/jobs/:id` rather than each unique id).
 *
 * Templates here must mirror the <Route path=...> definitions in App.tsx. When
 * a new route is added there, add the matching template + jobId-extraction
 * rule here too.
 */
export interface RouteMatch {
  template: string;
  jobId?: string;
}

const JOB_DETAIL_RE = /^\/tools\/jobs\/([^/]+)\/?$/;

export function matchRouteTemplate(pathname: string): RouteMatch {
  const jobDetail = JOB_DETAIL_RE.exec(pathname);
  if (jobDetail) {
    return { template: '/tools/jobs/:id', jobId: jobDetail[1] };
  }
  // Known static routes — anything else gets stored as-is so we don't lose new
  // routes silently, but cardinality stays bounded because the app only has a
  // small set of distinct static paths.
  return { template: pathname };
}
